import React, { useState } from 'react';
import GiftCardCreate from './GiftCardCreate';
import GiftCardList from './GiftCardList';
import GiftCardDeactivate from './GiftCardDeactivate';
import ModalQR from './ModalQR';

const GiftCardManager = () => {
  const tabs = [
    { id: 'create', label: 'Crear' },
    { id: 'list', label: 'Listado' },
    { id: 'update', label: 'Actualizar Estado' }
  ];

  const [activeTab, setActiveTab] = useState('create');
  const [refreshList, setRefreshList] = useState(false);
  const [modalQR, setModalQR] = useState({ open: false, code: '' });

  const renderActiveTab = () => {
    switch (activeTab) {
      case 'create':
        return <GiftCardCreate onCreated={() => setRefreshList(!refreshList)} />;
      case 'list':
        return (
          <GiftCardList
            refreshList={refreshList}
            openQRModal={(code) => setModalQR({ open: true, code })}
          />
        );
      case 'update':
        return <GiftCardDeactivate onUpdated={() => setRefreshList(!refreshList)} />;
      default:
        return null;
    }
  };

  return (
    <div className="w-full min-h-screen bg-gradient-to-br from-pink-100 via-pink-50 to-white p-6">
      <div className="max-w-full mx-auto px-4">
        <h1 className="text-5xl font-extrabold text-center text-pink-700 mb-10 drop-shadow-lg">
          Gestión de Gift Cards
        </h1>

        <div className="flex justify-center mb-10">
          <div className="bg-white/60 backdrop-blur-lg rounded-xl p-4 shadow-lg flex space-x-4">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`relative px-6 py-3 font-medium rounded-full transition-all duration-300 ${
                  activeTab === tab.id
                    ? 'bg-pink-600 text-white shadow-md scale-105'
                    : 'text-pink-600 bg-white hover:bg-pink-100 border border-pink-300'
                }`}
              >
                {tab.label}
                {activeTab === tab.id && (
                  <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-3/4 h-1 bg-white rounded-full mt-1"></span>
                )}
              </button>
            ))}
          </div>
        </div>

        <div className="bg-white/70 backdrop-blur-md rounded-2xl shadow-xl p-6">
          {renderActiveTab()}
        </div>
      </div>

      {modalQR.open && (
        <ModalQR
          code={modalQR.code}
          onClose={() => setModalQR({ open: false, code: '' })}
        />
      )}
    </div>
  );
};

export default GiftCardManager;
